import { render, staticRenderFns } from "./UcInvoiceImportNotificationCard.yaml?vue&type=template&id=1dcecea6&component"
import script from "./UcInvoiceImportNotificationCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoiceImportNotificationCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports